import commons from './en/commons.json'
import attributes from './en/attributes.json'
import models from './en/models.json'
import account from './en/account.json'
import errors from './en/errors.json'
import cookie from './en/cookie.json'
import { en } from 'vuetify/locale'

//custom vuetify locales
en.fileUpload.title = "Upload file here";
en.fileUpload.divider = "or";
en.fileUpload.browse = "Select file";

const lang = {
    $vuetify: en,
    commons: commons,
    attributes: attributes,
    models:models,
    account: account,
    errors: errors,
    cookie:cookie
}

export default lang